import React, { useState,useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  InputAdornment,
  IconButton,
  Card,
  CardContent,
  useTheme,
  Divider,
  Dialog,
} from "@mui/material";

import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import LockIcon from "@mui/icons-material/Lock";

import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { baseapi } from "../../Environmentalurl";
import { entity_id, getGeolocation, location, locationGeo, Platform } from "../../Utils/Const";
import useIPAddress from "../../Utils/useIPAddress";
import ArrowBackIosNewOutlined from "@mui/icons-material/ArrowBackIosNewOutlined";
import DashboardHeader from "../../Dashboard/DashboardHeader";
import api from "../../Utils/Api";

const Updatetpin = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const navigate = useNavigate();
  const ip = useIPAddress();

  const [showNewTpin, setShowNewTpin] = useState(false);
  const [showConfirmTpin, setShowConfirmTpin] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  const [newTpin, setNewTpin] = useState("");
  const [confirmTpin, setConfirmTpin] = useState("");

  const mobileNumber = JSON.parse(sessionStorage.getItem("mobileNumber"));

  const handleChangeTpin = async () => {
    if (newTpin !== confirmTpin) {
      toast.error("TPINs do not match.");
      return;
    }

    try {
      const payload = {
        ReqType: "MT_TPIN_Management",
        Mobilenumber: mobileNumber,
        Statement: "AddTPIN",
        TPIN: newTpin,
        OldTPIN: "",
        IsTPINEnabled: "True",
        Platform: Platform,
        EntityID: entity_id,
        GeoLocation: locationGeo,
        MachineID: ip,
      };

      const response = await api.post(`${baseapi}/tpin`, payload);

      if (response.data?.Response_Code === "1710") {
        setSuccessDialog(true); // show popup
      } else {
        toast.error(response.data?.Message || "Failed to reset TPIN");
      }
    } catch (err) {
      toast.error("Error occurred while resetting TPIN.");
    }
  };

  const greenInputStyle = {
    "& .MuiOutlinedInput-root fieldset": {
      borderColor: isDark ? "#868888ff" : "success.main",
    },
    "& .MuiOutlinedInput-root:hover fieldset": {
      borderColor: isDark ? "#868888ff" : "success.light",
    },
    "& .MuiOutlinedInput-root.Mui-focused fieldset": {
      borderColor: isDark ? "#868888ff" : "success.dark",
    },
    "& .MuiInputBase-input": {
      color: isDark ? "#f1f5f9" : "#000",
    },
    "& .MuiInputLabel-root": {
      color: isDark ? "#cbd5e1" : "#555",
    },
  };

  const handlehomenavigation = () => {
    navigate("/profile-settings/tpin");
  };

  return (
    <>
      {/* PAGE BACKGROUND */}
      <DashboardHeader/>
      <Box
        sx={{
          width: "100%",
          minHeight: "100vh",
          backgroundColor: isDark ? "#0a122a" : "#f4f7fb",
          p: { xs: 2, md: 4 },
        }}
      >
        {/* CENTER CARD */}
        <Card
          sx={{
            maxWidth: 500,
            mx: "auto",
            mt: { xs: 4, sm: 6 },
            borderRadius: 3,
            backgroundColor: isDark ? "#1e293b" : "#ffffff",
            boxShadow: isDark
              ? "0px 0px 10px rgba(255,255,255,0.06)"
              : "0px 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          <CardContent sx={{ p: 4 }}>
            {/* HEADING */}
            <Box display="flex" alignItems="center" mb={3}>
              <IconButton onClick={() => navigate("/profile-settings/tpin")}>
                <ArrowBackIosNewIcon
                  sx={{ color: isDark ? "#e2e8f0" : "#333" }}
                />
              </IconButton>
              <Typography
                variant="h6"
                fontWeight="bold"
                sx={{ color: isDark ? "#f1f5f9" : "#111" }}
              >
               
                Update TPIN
              </Typography>
            </Box>

            {/* NEW TPIN */}
            <TextField
              fullWidth
              label="New TPIN"
              type={showNewTpin ? "text" : "password"}
              value={newTpin}
              onChange={(e) => setNewTpin(e.target.value)}
              margin="normal"
              sx={greenInputStyle}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowNewTpin(!showNewTpin)}>
                      {showNewTpin ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* CONFIRM TPIN */}
            <TextField
              fullWidth
              label="Confirm New TPIN"
              type={showConfirmTpin ? "text" : "password"}
              value={confirmTpin}
              onChange={(e) => setConfirmTpin(e.target.value)}
              margin="normal"
              sx={greenInputStyle}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowConfirmTpin(!showConfirmTpin)}
                    >
                      {showConfirmTpin ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* SECURITY TIPS */}
            <Box
              sx={{
                backgroundColor: isDark ? "#0f172a" : "#e9f5e9",
                p: 2,
                mt: 2,
                borderRadius: 2,
              }}
            >
              <Typography
                fontWeight="bold"
                color="success.main"
                variant="body2"
                gutterBottom
              >
                Security Tips:
              </Typography>

              <Typography variant="caption" display="block">
                • Use a combination of numbers
              </Typography>
              <Typography variant="caption" display="block">
                • Avoid sequential numbers
              </Typography>
              <Typography variant="caption" display="block">
                • Don’t share your TPIN
              </Typography>
              <Typography variant="caption" display="block">
                • Change your TPIN regularly
              </Typography>
            </Box>

            {/* SUBMIT BUTTON */}
            <Button
              variant="contained"
              color="success"
              fullWidth
              sx={{ mt: 3 }}
              onClick={handleChangeTpin}
            >
              Set TPIN
            </Button>
          </CardContent>
        </Card>
      </Box>

      <ToastContainer position="top-right" autoClose={4000} hideProgressBar />

      {/* SUCCESS POPUP */}
      <Dialog
        open={successDialog}
        onClose={() => setSuccessDialog(false)}
        maxWidth="xs"
        fullWidth
      >
        <Box textAlign="center" py={3}>
          <Box
            display="inline-flex"
            justifyContent="center"
            alignItems="center"
            width={70}
            height={70}
            borderRadius="50%"
            bgcolor="#22c55e"
            color="white"
            mx="auto"
            mb={2}
          >
            <LockIcon sx={{ fontSize: 40 }} />
          </Box>

          <Typography variant="h6" fontWeight={"bold"}>
            TPIN Updated Successfully
          </Typography>

          <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
            Please login again using your latest TPIN.
          </Typography>

          <Box mt={3}>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                setSuccessDialog(false);
                sessionStorage.clear();
                localStorage.clear();
                navigate("/login");
              }}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default Updatetpin;
